var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFavorite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9328 19.6777L10.9314 19.6764C7.82173 16.8591 5.32124 14.5883 3.58648 12.4679C1.86269 10.3609 1 8.5249 1 6.59401C1 3.44371 3.45424 1 6.6 1C8.38603 1 10.1165 1.83586 11.2415 3.14536L12 4.02836L12.7585 3.14536C13.8835 1.83586 15.614 1 17.4 1C20.5458 1 23 3.4437 23 6.59401C23 8.5249 22.1373 10.3609 20.4135 12.4679C18.6788 14.5883 16.1783 16.8591 13.0686 19.6763L13.0672 19.6777L12 20.6483L10.9328 19.6777Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFavorite);
export default __webpack_public_path__ + "static/media/noFavorite.3ddeff060375d96ede82fbc1a00d3d49.svg";
export { ForwardRef as ReactComponent };